import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../components/helpers/AuthContext";
import { refreshAuthenticatedUser } from "../../components/helpers/AuthenticationHelpers";

function RegistrationComplete() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const redirectStatus = query.get("redirect_status");

    if (redirectStatus === "succeeded") {
      const selectedAccountType = sessionStorage.getItem("selectedAccountType");
      const isUpgrade = !!sessionStorage.getItem("customer") && ["team", "enterprise"].includes(selectedAccountType);

      if (isUpgrade) {
        refreshAuthenticatedUser().then((freshCustomer) => {
          if (freshCustomer) {
            login(freshCustomer);
            navigate("/your-profile/team");
          } else {
            navigate("/your-profile");
          }
        });
      } else {
        navigate("/register/successful");
      }
    } else if (redirectStatus === "failed") {
      navigate("/register/failed");
    } else {
      console.error("Unknown redirect status:", redirectStatus);
      navigate("/register/failed"); // Default to failure for unknown status
    }
  }, [location.search, login, navigate]); // Depend on location.search and navigate

  return null; // No UI rendering
}

export default RegistrationComplete;
